// Maps look-alike unicode characters to the ASCII symbol the editor actually
// recognizes. Some keyboard layouts emit these variants instead of the plain
// ASCII symbol, which would otherwise fail to trigger suggestions.
//
// e.g. AZERTY keyboards emit ˆ (U+02C6 MODIFIER LETTER CIRCUMFLEX ACCENT)
// instead of ^ (U+005E CIRCUMFLEX ACCENT). The two are visually identical, but
// only ^ triggers exponent / superscript / power / hat suggestions.
//
// Note: Unicode NFKC normalization does NOT map these, so the replacements have
// to be explicit. Add more entries here as new look-alikes turn up.
export const SYMBOL_ALIASES: Readonly<Record<string, string>> = {
  ˆ: "^",
};

const SYMBOL_ALIASES_PATTERN = new RegExp(`[${Object.keys(SYMBOL_ALIASES).join("")}]`, "g");

export function normalizeSymbols(text: string): string {
  return text.replace(SYMBOL_ALIASES_PATTERN, (char) => SYMBOL_ALIASES[char] ?? char);
}
